// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reminders-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2rem;
  color: #ffffff;
  margin: 0;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);
}

.btn-secondary {
  background: #6b7280;
  color: white;
}

.btn-secondary:hover {
  background: #4b5563;
}

/* Add Form - Uses glass-panel from design-system.css */
.add-form-container {
  /* Inherits from .glass-panel via class in JSX */
  padding: 25px;
  margin-bottom: 30px;
}

.reminder-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group label {
  font-weight: 600;
  color: #ffffff;
  font-size: 0.9rem;
}

.input-group input,
.input-group textarea {
  padding: 10px 12px;
  background: rgba(15, 23, 42, 0.6);
  color: var(--white);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.input-group input:focus,
.input-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

/* Date input — natívny kalendárik v dark theme */
.input-group input[type="date"] {
  color-scheme: dark;
  font-family: inherit;
  cursor: pointer;
}

.input-group input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.85);
  cursor: pointer;
  opacity: 0.8;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
}

.input-group input[type="date"]::-webkit-calendar-picker-indicator:hover {
  opacity: 1;
}

.input-group input[type="date"]::-webkit-datetime-edit-text,
.input-group input[type="date"]::-webkit-datetime-edit-month-field,
.input-group input[type="date"]::-webkit-datetime-edit-day-field,
.input-group input[type="date"]::-webkit-datetime-edit-year-field {
  color: var(--white);
}

.form-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

/* Reminders List */
.reminders-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.reminder-item {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 16px 20px;
  transition: all 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.reminder-item:hover {
  background: rgba(99, 102, 241, 0.08);
  border-color: rgba(99, 102, 241, 0.2);
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.2);
}

.reminder-item.completed {
  opacity: 0.6;
  background: rgba(255, 255, 255, 0.02);
}

.reminder-item.completed .reminder-title {
  text-decoration: line-through;
  color: rgba(255, 255, 255, 0.5);
}

.reminder-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.checkbox-btn {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
  color: white;
}

.checkbox-btn:hover {
  border-color: var(--primary-color);
  background: rgba(99, 102, 241, 0.15);
}

.reminder-item.completed .checkbox-btn {
  background: #10b981;
  border-color: #10b981;
}

.reminder-info {
  flex: 1 1;
  min-width: 0;
}

.reminder-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reminder-date {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #ffffff;
}

.reminder-date svg {
  font-size: 0.85rem;
}

.days-remaining {
  font-weight: 600;
  margin-left: 8px;
}

.reminder-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.reminder-description {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #ffffff;
  margin-top: 4px;
}

.reminder-description svg {
  font-size: 0.8rem;
  flex-shrink: 0;
}

.reminder-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.edit-btn {
  color: #3b82f6;
}

.edit-btn:hover {
  background: #dbeafe;
}

.attachment-btn {
  color: #8b5cf6;
}

.attachment-btn:hover {
  background: #ede9fe;
}

.delete-btn {
  color: #ef4444;
}

.delete-btn:hover {
  background: #fee2e2;
}

/* Progress Bar */
.progress-container {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.progress-bar {
  height: 8px;
  background: #f3f4f6;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  border-radius: 4px;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, 
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Attachments */
.attachments-list {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.attachment-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  font-size: 0.85rem;
  color: #ffffff;
}

.attachment-item svg {
  font-size: 0.8rem;
  color: #8b5cf6;
}

.att-desc {
  font-style: italic;
  color: rgba(255, 255, 255, 0.8);
  margin-left: 4px;
}

/* Form Title */
.reminder-form h3 {
  margin: 0 0 20px 0;
  color: #ffffff;
  font-size: 1.2rem;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: rgba(255, 255, 255, 0.8);
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.3;
}

.empty-state h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #ffffff;
}

.empty-state p {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e5e7eb;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Pending Files */
.pending-files {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.pending-file-item {
  display: flex;
  align-items: center;
  padding: 8px;
  background: #f9fafb;
  border-radius: 6px;
  gap: 8px;
}

.pending-file-item span {
  font-size: 0.9rem;
  color: #ffffff;
  min-width: 150px;
}

.pending-file-item input[type="text"] {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 0.9rem;
}

.btn-icon.delete {
  background: transparent;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.btn-icon.delete:hover {
  background: #fee2e2;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 2px solid #e5e7eb;
}

.modal-header h2 {
  margin: 0;
  color: #ffffff;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.modal-body {
  padding: 20px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  color: #ffffff;
}

.detail-item svg {
  color: #667eea;
  flex-shrink: 0;
}

.detail-section {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.detail-section h3 {
  margin: 0 0 15px 0;
  color: #ffffff;
  font-size: 1.1rem;
}

.attachments-detail {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.attachment-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f9fafb;
  border-radius: 6px;
  transition: background 0.2s;
}

.attachment-detail-item:hover {
  background: #f3f4f6;
}

.attachment-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
}

.attachment-info svg {
  color: #8b5cf6;
  flex-shrink: 0;
}

.attachment-link {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.attachment-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

.attachment-desc {
  color: rgba(255, 255, 255, 0.9);
  font-style: italic;
  font-size: 0.9rem;
}

.no-attachments {
  color: rgba(255, 255, 255, 0.7);
  font-style: italic;
  text-align: center;
  padding: 20px;
}

.reminder-title.clickable:hover {
  color: #667eea;
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .page-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .reminder-content {
    gap: 12px;
  }
  
  .reminder-title {
    font-size: 1rem;
  }
  
  .days-remaining {
    display: block;
    margin-left: 0;
    margin-top: 4px;
  }
}
/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .reminders-page,
[data-theme="light"] .reminder-card,
[data-theme="light"] .reminder-form {
  color: #1e293b;
}

[data-theme="light"] .reminder-card h3,
[data-theme="light"] .reminder-form h2,
[data-theme="light"] .form-group label {
  color: #1e293b;
}

[data-theme="light"] .reminder-date,
[data-theme="light"] .reminder-description {
  color: #475569;
}

[data-theme="light"] .form-group input,
[data-theme="light"] .form-group textarea,
[data-theme="light"] .form-group select {
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  border: 1px solid rgba(15, 23, 42, 0.15);
}

/* More comprehensive light theme overrides */
[data-theme="light"] .page-header h1 {
  color: #1e293b;
}

[data-theme="light"] .input-group label {
  color: #1e293b;
}

[data-theme="light"] .input-group input,
[data-theme="light"] .input-group textarea {
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  border: 2px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .input-group input:focus,
[data-theme="light"] .input-group textarea:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .reminder-item {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .reminder-item:hover {
  background: rgba(100, 116, 139, 0.08);
  border-color: rgba(100, 116, 139, 0.2);
  box-shadow: 0 4px 12px rgba(100, 116, 139, 0.15);
}

[data-theme="light"] .reminder-item.completed {
  background: rgba(226, 232, 240, 0.5);
}

[data-theme="light"] .reminder-item.completed .reminder-title {
  color: rgba(30, 41, 59, 0.5);
}

[data-theme="light"] .reminder-title {
  color: #1e293b;
}

[data-theme="light"] .reminder-date {
  color: #475569;
}

[data-theme="light"] .reminder-description {
  color: #64748b;
}

[data-theme="light"] .checkbox-btn {
  border: 2px solid rgba(15, 23, 42, 0.2);
  background: rgba(255, 255, 255, 0.5);
  color: #1e293b;
}

[data-theme="light"] .checkbox-btn:hover {
  border-color: var(--primary-color);
  background: rgba(100, 116, 139, 0.15);
}

[data-theme="light"] .attachment-item {
  background: rgba(100, 116, 139, 0.1);
  color: #1e293b;
}

[data-theme="light"] .att-desc {
  color: rgba(30, 41, 59, 0.7);
}

[data-theme="light"] .reminder-form h3 {
  color: #1e293b;
}

[data-theme="light"] .empty-state {
  color: rgba(30, 41, 59, 0.7);
}

[data-theme="light"] .empty-state h3 {
  color: #1e293b;
}

[data-theme="light"] .empty-state p {
  color: rgba(30, 41, 59, 0.7);
}

[data-theme="light"] .pending-file-item {
  background: rgba(241, 245, 249, 0.8);
}

[data-theme="light"] .pending-file-item span {
  color: #1e293b;
}

[data-theme="light"] .modal-content {
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(15, 23, 42, 0.1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

[data-theme="light"] .modal-header h2 {
  color: #1e293b;
}

[data-theme="light"] .close-btn {
  color: rgba(30, 41, 59, 0.7);
}

[data-theme="light"] .close-btn:hover {
  background: rgba(100, 116, 139, 0.1);
  color: #1e293b;
}

[data-theme="light"] .detail-item {
  color: #1e293b;
}

[data-theme="light"] .detail-section h3 {
  color: #1e293b;
}

[data-theme="light"] .attachment-detail-item {
  background: rgba(241, 245, 249, 0.8);
}

[data-theme="light"] .attachment-detail-item:hover {
  background: rgba(226, 232, 240, 0.8);
}

[data-theme="light"] .attachment-desc {
  color: rgba(30, 41, 59, 0.8);
}

[data-theme="light"] .no-attachments {
  color: rgba(30, 41, 59, 0.6);
}

[data-theme="light"] .edit-btn:hover {
  background: rgba(59, 130, 246, 0.1);
}

[data-theme="light"] .attachment-btn:hover {
  background: rgba(139, 92, 246, 0.1);
}

[data-theme="light"] .delete-btn:hover {
  background: rgba(239, 68, 68, 0.1);
}

[data-theme="light"] .btn-icon.delete:hover {
  background: rgba(239, 68, 68, 0.1);
}

[data-theme="light"] .page-header {
  border-bottom: 2px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .modal-header {
  border-bottom: 2px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .detail-section {
  border-top: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .progress-container {
  border-top: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .attachments-list {
  border-top: 1px solid rgba(15, 23, 42, 0.1);
}

/* ============================================================
   Cleaner form styling for category, visibility, file upload
   ============================================================ */

.reminder-select,
.reminder-input {
  width: 100%;
  padding: 10px 12px;
  background: rgba(15, 23, 42, 0.6);
  color: var(--white);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.reminder-select:focus,
.reminder-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.reminder-select option {
  background: #1e293b;
  color: #e2e8f0;
}

/* New category panel */
.new-category-panel {
  margin-top: 10px;
  padding: 18px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
}

.new-category-panel h4 {
  margin: 0 0 14px 0;
  color: var(--white);
  font-size: 1rem;
  font-weight: 600;
}

.new-category-panel .reminder-input {
  margin-bottom: 14px;
}

.cat-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  align-items: flex-start;
}

.cat-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cat-col:first-child { flex: 1 1; }

.cat-sublabel {
  font-size: 0.75rem;
  color: rgba(226, 232, 240, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.icon-picker {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.icon-btn {
  width: 38px;
  height: 38px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.icon-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

.icon-btn.selected {
  border-color: var(--primary-color);
  background: rgba(99, 102, 241, 0.2);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.color-picker {
  width: 54px;
  height: 38px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  background: transparent;
  padding: 0;
}

.cat-actions {
  display: flex;
  gap: 10px;
}

.btn-sm {
  padding: 8px 16px !important;
  font-size: 0.9rem !important;
}

/* Visibility toggle */
.visibility-toggle {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.vis-option {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  cursor: pointer;
  color: rgba(226, 232, 240, 0.7);
  font-size: 0.95rem;
  transition: all 0.2s;
}

.vis-option:hover {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.15);
}

.vis-option.active {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.18), rgba(139, 92, 246, 0.18));
  border-color: rgba(99, 102, 241, 0.5);
  color: var(--white);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.vis-option input[type="radio"] {
  accent-color: var(--primary-color);
  cursor: pointer;
}

.vis-icon {
  font-size: 1.1rem;
}

/* Share panel */
.share-panel {
  margin-top: 12px;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
}

.share-label {
  display: block;
  margin: 0 0 12px 0;
  font-size: 0.75rem;
  color: rgba(226, 232, 240, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.share-users {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.share-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  color: #e2e8f0;
  font-size: 0.95rem;
  transition: background 0.15s;
}

.share-user:hover {
  background: rgba(255, 255, 255, 0.05);
}

.share-user input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--primary-color);
  cursor: pointer;
}

.share-user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
}

.share-user-name {
  flex: 1 1;
}

.share-empty {
  color: rgba(226, 232, 240, 0.5);
  font-size: 0.9rem;
  margin: 6px 0 0 0;
}

/* File input styling */
.reminder-file-input {
  width: 100%;
  padding: 10px;
  background: rgba(15, 23, 42, 0.6);
  border: 2px dashed rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(226, 232, 240, 0.7);
  cursor: pointer;
  font-size: 0.9rem;
  margin-bottom: 10px;
  transition: border-color 0.2s;
}

.reminder-file-input:hover {
  border-color: rgba(99, 102, 241, 0.4);
}

.reminder-file-input::file-selector-button {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.3), rgba(139, 92, 246, 0.3));
  border: 1px solid rgba(99, 102, 241, 0.3);
  color: var(--white);
  padding: 6px 14px;
  border-radius: 6px;
  margin-right: 12px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.15s;
}

.reminder-file-input::file-selector-button:hover {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.45), rgba(139, 92, 246, 0.45));
}

/* Light theme fallback */
[data-theme="light"] .vis-option {
  background: rgba(15, 23, 42, 0.03);
  border-color: rgba(15, 23, 42, 0.1);
  color: #475569;
}

[data-theme="light"] .vis-option.active {
  color: #1e293b;
}

[data-theme="light"] .share-panel,
[data-theme="light"] .new-category-panel {
  background: rgba(15, 23, 42, 0.03);
  border-color: rgba(15, 23, 42, 0.08);
}

[data-theme="light"] .share-user,
[data-theme="light"] .share-user-name,
[data-theme="light"] .new-category-panel h4 {
  color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./src/features/reminders/Reminders.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,gDAAgD;EAChD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gCAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;GAIC;EACD,8BAA8B;AAChC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;AACF;AACA,oDAAoD;AACpD;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;;AAEA,6CAA6C;AAC7C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;EAEE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;iEAEiE;;AAEjE;;EAEE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,uBAAuB,SAAO,EAAE;;AAEhC;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;EAC7C,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,uFAAuF;EACvF,qCAAqC;EACrC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,4CAA4C;EAC5C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qFAAqF;EACrF,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uFAAuF;AACzF;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;EAClC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB","sourcesContent":[".reminders-page {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.page-header h1 {\n  font-size: 2rem;\n  color: #ffffff;\n  margin: 0;\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);\n}\n\n.btn-secondary {\n  background: #6b7280;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #4b5563;\n}\n\n/* Add Form - Uses glass-panel from design-system.css */\n.add-form-container {\n  /* Inherits from .glass-panel via class in JSX */\n  padding: 25px;\n  margin-bottom: 30px;\n}\n\n.reminder-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.input-group label {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 0.9rem;\n}\n\n.input-group input,\n.input-group textarea {\n  padding: 10px 12px;\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--white);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s;\n}\n\n.input-group input:focus,\n.input-group textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n/* Date input — natívny kalendárik v dark theme */\n.input-group input[type=\"date\"] {\n  color-scheme: dark;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.input-group input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: invert(0.85);\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n\n.input-group input[type=\"date\"]::-webkit-calendar-picker-indicator:hover {\n  opacity: 1;\n}\n\n.input-group input[type=\"date\"]::-webkit-datetime-edit-text,\n.input-group input[type=\"date\"]::-webkit-datetime-edit-month-field,\n.input-group input[type=\"date\"]::-webkit-datetime-edit-day-field,\n.input-group input[type=\"date\"]::-webkit-datetime-edit-year-field {\n  color: var(--white);\n}\n\n.form-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n/* Reminders List */\n.reminders-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.reminder-item {\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 12px;\n  padding: 16px 20px;\n  transition: all 0.3s;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.reminder-item:hover {\n  background: rgba(99, 102, 241, 0.08);\n  border-color: rgba(99, 102, 241, 0.2);\n  transform: translateX(4px);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.2);\n}\n\n.reminder-item.completed {\n  opacity: 0.6;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.reminder-item.completed .reminder-title {\n  text-decoration: line-through;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.reminder-content {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.checkbox-btn {\n  width: 24px;\n  height: 24px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s;\n  color: white;\n}\n\n.checkbox-btn:hover {\n  border-color: var(--primary-color);\n  background: rgba(99, 102, 241, 0.15);\n}\n\n.reminder-item.completed .checkbox-btn {\n  background: #10b981;\n  border-color: #10b981;\n}\n\n.reminder-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.reminder-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 4px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.reminder-date {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  color: #ffffff;\n}\n\n.reminder-date svg {\n  font-size: 0.85rem;\n}\n\n.days-remaining {\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.reminder-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.reminder-description {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  color: #ffffff;\n  margin-top: 4px;\n}\n\n.reminder-description svg {\n  font-size: 0.8rem;\n  flex-shrink: 0;\n}\n\n.reminder-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.action-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 6px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n}\n\n.edit-btn {\n  color: #3b82f6;\n}\n\n.edit-btn:hover {\n  background: #dbeafe;\n}\n\n.attachment-btn {\n  color: #8b5cf6;\n}\n\n.attachment-btn:hover {\n  background: #ede9fe;\n}\n\n.delete-btn {\n  color: #ef4444;\n}\n\n.delete-btn:hover {\n  background: #fee2e2;\n}\n\n/* Progress Bar */\n.progress-container {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f3f4f6;\n}\n\n.progress-bar {\n  height: 8px;\n  background: #f3f4f6;\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-fill {\n  height: 100%;\n  border-radius: 4px;\n  position: relative;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.progress-fill::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(90deg, \n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.3) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n/* Attachments */\n.attachments-list {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f3f4f6;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.attachment-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  font-size: 0.85rem;\n  color: #ffffff;\n}\n\n.attachment-item svg {\n  font-size: 0.8rem;\n  color: #8b5cf6;\n}\n\n.att-desc {\n  font-style: italic;\n  color: rgba(255, 255, 255, 0.8);\n  margin-left: 4px;\n}\n\n/* Form Title */\n.reminder-form h3 {\n  margin: 0 0 20px 0;\n  color: #ffffff;\n  font-size: 1.2rem;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  opacity: 0.3;\n}\n\n.empty-state h3 {\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n  color: #ffffff;\n}\n\n.empty-state p {\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Pending Files */\n.pending-files {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.pending-file-item {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  background: #f9fafb;\n  border-radius: 6px;\n  gap: 8px;\n}\n\n.pending-file-item span {\n  font-size: 0.9rem;\n  color: #ffffff;\n  min-width: 150px;\n}\n\n.pending-file-item input[type=\"text\"] {\n  flex: 1;\n  padding: 6px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.btn-icon.delete {\n  background: transparent;\n  border: none;\n  color: #ef4444;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.btn-icon.delete:hover {\n  background: #fee2e2;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: rgba(15, 23, 42, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #ffffff;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  color: rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.detail-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 15px;\n  color: #ffffff;\n}\n\n.detail-item svg {\n  color: #667eea;\n  flex-shrink: 0;\n}\n\n.detail-section {\n  margin-top: 25px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.detail-section h3 {\n  margin: 0 0 15px 0;\n  color: #ffffff;\n  font-size: 1.1rem;\n}\n\n.attachments-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.attachment-detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background: #f9fafb;\n  border-radius: 6px;\n  transition: background 0.2s;\n}\n\n.attachment-detail-item:hover {\n  background: #f3f4f6;\n}\n\n.attachment-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n}\n\n.attachment-info svg {\n  color: #8b5cf6;\n  flex-shrink: 0;\n}\n\n.attachment-link {\n  color: #3b82f6;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.attachment-link:hover {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.attachment-desc {\n  color: rgba(255, 255, 255, 0.9);\n  font-style: italic;\n  font-size: 0.9rem;\n}\n\n.no-attachments {\n  color: rgba(255, 255, 255, 0.7);\n  font-style: italic;\n  text-align: center;\n  padding: 20px;\n}\n\n.reminder-title.clickable:hover {\n  color: #667eea;\n  text-decoration: underline;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .page-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .reminder-content {\n    gap: 12px;\n  }\n  \n  .reminder-title {\n    font-size: 1rem;\n  }\n  \n  .days-remaining {\n    display: block;\n    margin-left: 0;\n    margin-top: 4px;\n  }\n}\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .reminders-page,\n[data-theme=\"light\"] .reminder-card,\n[data-theme=\"light\"] .reminder-form {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .reminder-card h3,\n[data-theme=\"light\"] .reminder-form h2,\n[data-theme=\"light\"] .form-group label {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .reminder-date,\n[data-theme=\"light\"] .reminder-description {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .form-group input,\n[data-theme=\"light\"] .form-group textarea,\n[data-theme=\"light\"] .form-group select {\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n/* More comprehensive light theme overrides */\n[data-theme=\"light\"] .page-header h1 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .input-group label {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .input-group input,\n[data-theme=\"light\"] .input-group textarea {\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  border: 2px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .input-group input:focus,\n[data-theme=\"light\"] .input-group textarea:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .reminder-item {\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .reminder-item:hover {\n  background: rgba(100, 116, 139, 0.08);\n  border-color: rgba(100, 116, 139, 0.2);\n  box-shadow: 0 4px 12px rgba(100, 116, 139, 0.15);\n}\n\n[data-theme=\"light\"] .reminder-item.completed {\n  background: rgba(226, 232, 240, 0.5);\n}\n\n[data-theme=\"light\"] .reminder-item.completed .reminder-title {\n  color: rgba(30, 41, 59, 0.5);\n}\n\n[data-theme=\"light\"] .reminder-title {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .reminder-date {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .reminder-description {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .checkbox-btn {\n  border: 2px solid rgba(15, 23, 42, 0.2);\n  background: rgba(255, 255, 255, 0.5);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .checkbox-btn:hover {\n  border-color: var(--primary-color);\n  background: rgba(100, 116, 139, 0.15);\n}\n\n[data-theme=\"light\"] .attachment-item {\n  background: rgba(100, 116, 139, 0.1);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .att-desc {\n  color: rgba(30, 41, 59, 0.7);\n}\n\n[data-theme=\"light\"] .reminder-form h3 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .empty-state {\n  color: rgba(30, 41, 59, 0.7);\n}\n\n[data-theme=\"light\"] .empty-state h3 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .empty-state p {\n  color: rgba(30, 41, 59, 0.7);\n}\n\n[data-theme=\"light\"] .pending-file-item {\n  background: rgba(241, 245, 249, 0.8);\n}\n\n[data-theme=\"light\"] .pending-file-item span {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .modal-content {\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n[data-theme=\"light\"] .modal-header h2 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .close-btn {\n  color: rgba(30, 41, 59, 0.7);\n}\n\n[data-theme=\"light\"] .close-btn:hover {\n  background: rgba(100, 116, 139, 0.1);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .detail-item {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .detail-section h3 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .attachment-detail-item {\n  background: rgba(241, 245, 249, 0.8);\n}\n\n[data-theme=\"light\"] .attachment-detail-item:hover {\n  background: rgba(226, 232, 240, 0.8);\n}\n\n[data-theme=\"light\"] .attachment-desc {\n  color: rgba(30, 41, 59, 0.8);\n}\n\n[data-theme=\"light\"] .no-attachments {\n  color: rgba(30, 41, 59, 0.6);\n}\n\n[data-theme=\"light\"] .edit-btn:hover {\n  background: rgba(59, 130, 246, 0.1);\n}\n\n[data-theme=\"light\"] .attachment-btn:hover {\n  background: rgba(139, 92, 246, 0.1);\n}\n\n[data-theme=\"light\"] .delete-btn:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n[data-theme=\"light\"] .btn-icon.delete:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n[data-theme=\"light\"] .page-header {\n  border-bottom: 2px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .modal-header {\n  border-bottom: 2px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .detail-section {\n  border-top: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .progress-container {\n  border-top: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .attachments-list {\n  border-top: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n/* ============================================================\n   Cleaner form styling for category, visibility, file upload\n   ============================================================ */\n\n.reminder-select,\n.reminder-input {\n  width: 100%;\n  padding: 10px 12px;\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--white);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s;\n  box-sizing: border-box;\n}\n\n.reminder-select:focus,\n.reminder-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n.reminder-select option {\n  background: #1e293b;\n  color: #e2e8f0;\n}\n\n/* New category panel */\n.new-category-panel {\n  margin-top: 10px;\n  padding: 18px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n}\n\n.new-category-panel h4 {\n  margin: 0 0 14px 0;\n  color: var(--white);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.new-category-panel .reminder-input {\n  margin-bottom: 14px;\n}\n\n.cat-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n  align-items: flex-start;\n}\n\n.cat-col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cat-col:first-child { flex: 1; }\n\n.cat-sublabel {\n  font-size: 0.75rem;\n  color: rgba(226, 232, 240, 0.55);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.icon-picker {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.icon-btn {\n  width: 38px;\n  height: 38px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.04);\n  cursor: pointer;\n  font-size: 1.1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.icon-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.icon-btn.selected {\n  border-color: var(--primary-color);\n  background: rgba(99, 102, 241, 0.2);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.color-picker {\n  width: 54px;\n  height: 38px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  cursor: pointer;\n  background: transparent;\n  padding: 0;\n}\n\n.cat-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-sm {\n  padding: 8px 16px !important;\n  font-size: 0.9rem !important;\n}\n\n/* Visibility toggle */\n.visibility-toggle {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.vis-option {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1.5px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  cursor: pointer;\n  color: rgba(226, 232, 240, 0.7);\n  font-size: 0.95rem;\n  transition: all 0.2s;\n}\n\n.vis-option:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.vis-option.active {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.18), rgba(139, 92, 246, 0.18));\n  border-color: rgba(99, 102, 241, 0.5);\n  color: var(--white);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.vis-option input[type=\"radio\"] {\n  accent-color: var(--primary-color);\n  cursor: pointer;\n}\n\n.vis-icon {\n  font-size: 1.1rem;\n}\n\n/* Share panel */\n.share-panel {\n  margin-top: 12px;\n  padding: 16px 18px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n}\n\n.share-label {\n  display: block;\n  margin: 0 0 12px 0;\n  font-size: 0.75rem;\n  color: rgba(226, 232, 240, 0.55);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.share-users {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.share-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #e2e8f0;\n  font-size: 0.95rem;\n  transition: background 0.15s;\n}\n\n.share-user:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.share-user input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--primary-color);\n  cursor: pointer;\n}\n\n.share-user-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: white;\n  text-transform: uppercase;\n}\n\n.share-user-name {\n  flex: 1;\n}\n\n.share-empty {\n  color: rgba(226, 232, 240, 0.5);\n  font-size: 0.9rem;\n  margin: 6px 0 0 0;\n}\n\n/* File input styling */\n.reminder-file-input {\n  width: 100%;\n  padding: 10px;\n  background: rgba(15, 23, 42, 0.6);\n  border: 2px dashed rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: rgba(226, 232, 240, 0.7);\n  cursor: pointer;\n  font-size: 0.9rem;\n  margin-bottom: 10px;\n  transition: border-color 0.2s;\n}\n\n.reminder-file-input:hover {\n  border-color: rgba(99, 102, 241, 0.4);\n}\n\n.reminder-file-input::file-selector-button {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.3), rgba(139, 92, 246, 0.3));\n  border: 1px solid rgba(99, 102, 241, 0.3);\n  color: var(--white);\n  padding: 6px 14px;\n  border-radius: 6px;\n  margin-right: 12px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.15s;\n}\n\n.reminder-file-input::file-selector-button:hover {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.45), rgba(139, 92, 246, 0.45));\n}\n\n/* Light theme fallback */\n[data-theme=\"light\"] .vis-option {\n  background: rgba(15, 23, 42, 0.03);\n  border-color: rgba(15, 23, 42, 0.1);\n  color: #475569;\n}\n\n[data-theme=\"light\"] .vis-option.active {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .share-panel,\n[data-theme=\"light\"] .new-category-panel {\n  background: rgba(15, 23, 42, 0.03);\n  border-color: rgba(15, 23, 42, 0.08);\n}\n\n[data-theme=\"light\"] .share-user,\n[data-theme=\"light\"] .share-user-name,\n[data-theme=\"light\"] .new-category-panel h4 {\n  color: #1e293b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
